var map = {
	"./demo1-poster.jpg": "bd6b",
	"./demo2-poster.jpg": "f9af",
	"./demo3-poster.jpg": "bd6a",
	"./demo4-poster.jpg": "c843",
	"./demo5-poster.jpg": "577c",
	"./demo6-poster.jpg": "ba48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "416a";